<template>
  <div>
    <!-- Disable Account Dialog -->
    <v-dialog v-model="disableAccBox" max-width="500" persistent>
      <v-card class="settings-dialog-card">
        <v-card-text align="center" class="pt-8 pb-4">
          <LogoWhite></LogoWhite>
        </v-card-text>

        <v-card-text v-if="!deactivateAccOK" class="px-6 pb-0">
          <v-form ref="disableAccRef" v-model="disableAcc" id="disable-acc-ok">
            <v-text-field
              autocomplete="current-password"
              class="dialog-field"
              v-model.lazy="passDisableAcc"
              label="Enter Password"
              :append-inner-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="() => (value = !value)"
              :type="value ? 'password' : 'text'"
              required
              color="white"
              variant="outlined"
              :rules="passwordRulesLogin"
              @focus="checkErrors()"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions v-if="!deactivateAccOK" class="px-6 pb-6 pt-4">
          <v-btn variant="outlined" @click="disableAccBox = false" class="dialog-btn">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            form="disable-acc-ok"
            :disabled="!disableAcc"
            variant="outlined"
            color="error"
            class="dialog-btn"
            @click="disableAccFun($event)"
          >
            Disable Account
          </v-btn>
        </v-card-actions>

        <v-card-text v-if="deactivateAccOK" align="center" class="pb-5 pt-4">
          <div class="success-message">
            <v-icon size="48" color="warning">mdi-alert-circle</v-icon>
            <h3 class="success-title">Account Disabled</h3>
            <p class="success-text">
              Account successfully disabled. You have 30 days to re-activate it.
              After 30 days we may remove your account permanently.
            </p>
          </div>
        </v-card-text>
        <v-card-actions v-if="deactivateAccOK" class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeDialogDisableAcc" class="dialog-btn">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Activate Account Dialog -->
    <v-dialog v-model="activateAccBox" max-width="500" persistent>
      <v-card class="settings-dialog-card">
        <v-card-text align="center" class="pt-8 pb-4">
          <LogoWhite></LogoWhite>
        </v-card-text>

        <v-card-text v-if="!activateAccOK" align="center" class="px-6 pt-4">
          <p class="dialog-confirm-text">Are you sure you want to reactivate your account?</p>
        </v-card-text>

        <v-card-actions v-if="!activateAccOK" class="px-6 pb-6 pt-4">
          <v-btn variant="outlined" @click="activateAccBox = false" class="dialog-btn">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="enableAcc"
            variant="outlined"
            color="success"
            class="dialog-btn"
            @click="activateAccFun($event)"
          >
            Confirm Activation
          </v-btn>
        </v-card-actions>

        <v-card-text v-if="activateAccOK" align="center" class="pb-5 pt-4">
          <div class="success-message">
            <v-icon size="48" color="success">mdi-check-circle</v-icon>
            <h3 class="success-title">Success!</h3>
            <p class="success-text">Account successfully reactivated!</p>
          </div>
        </v-card-text>
        <v-card-actions v-if="activateAccOK" class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeDialogActivateAcc" class="dialog-btn">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Change Email Dialog -->
    <v-dialog v-model="changeEmailBox" max-width="500" persistent>
      <v-card class="settings-dialog-card">
        <v-card-text align="center" class="pt-8 pb-4">
          <LogoWhite></LogoWhite>
        </v-card-text>

        <v-card-text v-if="!changeEmailOK" class="px-6 pb-0">
          <v-form ref="changeEmailRef" v-model="changeEmail" id="change-email-acc-ok">
            <v-text-field
              v-model="emailNew"
              class="dialog-field"
              :rules="emailRules"
              label="Enter New Email"
              required
              color="white"
              variant="outlined"
              @focus="checkErrorsRegister()"
              :error-messages="emailValidationErrors"
            ></v-text-field>

            <v-text-field
              autocomplete="current-password"
              class="dialog-field mt-4"
              v-model.lazy="passChangeEmail"
              label="Enter Password"
              :append-inner-icon="valueEmail ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append-inner="() => (valueEmail = !valueEmail)"
              :type="valueEmail ? 'password' : 'text'"
              required
              color="white"
              variant="outlined"
              :rules="passwordRulesLogin"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions v-if="!changeEmailOK" class="px-6 pb-6 pt-4">
          <v-btn variant="outlined" @click="changeEmailBox = false" class="dialog-btn">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            type="submit"
            form="change-email-acc-ok"
            :disabled="!changeEmail"
            variant="outlined"
            class="dialog-btn"
            @click="changeEmailFun($event)"
          >
            Change Email
          </v-btn>
        </v-card-actions>

        <v-card-text v-if="changeEmailOK" align="center" class="pb-5 pt-4">
          <div class="success-message">
            <v-icon size="48" color="success">mdi-check-circle</v-icon>
            <h3 class="success-title">Success!</h3>
            <p class="success-text">
              Email changed successfully. You can now login using your new e-mail address.
            </p>
          </div>
        </v-card-text>
        <v-card-actions v-if="changeEmailOK" class="px-6 pb-6">
          <v-spacer></v-spacer>
          <v-btn variant="outlined" @click="closeDialogChangeEmail" class="dialog-btn">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- File Uploaders -->
    <input ref="uploader2" class="d-none" type="file" @change="handleFileUploadFront($event)" />
    <input ref="uploader3" class="d-none" type="file" @change="handleFileUploadBack($event)" />
    <input ref="uploader4" class="d-none" type="file" @change="handleFileUploadAddress($event)" />
    <input ref="uploader5" class="d-none" type="file" @change="handleFileUploadCompany($event)" />

    <div class="pa-0 ma-0">
      <div class="body-overall">
        <v-row style="padding-top:64px!important"></v-row>
        <div :class="getGextPanel" class="pt-6" style="margin:0px!important;">
          <div class="fonts-white container pl-0 pr-1">
            <div v-if="this.user" class="overlay-grey-web">
              
              <!-- Header Section -->
              <div class="settings-header">
                <div class="header-content">
                  <v-icon class="header-icon">mdi-cog</v-icon>
                  <h1 class="header-title">Account Settings</h1>
                </div>
                <p class="header-subtitle">Manage your account preferences and security settings</p>
              </div>

              <v-divider class="my-4" style="opacity:0.3;"></v-divider>

              <!-- Account Status Section -->
              <div class="settings-section">
                <h2 class="section-title">
                  <v-icon left>mdi-account-check</v-icon>
                  Account Status
                </h2>

                <div class="status-cards-grid">
                  <v-card class="status-card">
                    <v-card-text>
                      <div class="status-card-content">
                        <div class="status-card-header">
                          <v-icon size="28" :color="user.active ? 'success' : 'error'">
                            mdi-shield-account
                          </v-icon>
                          <span class="status-card-label">Account Status</span>
                        </div>
                        <v-chip
                          :color="user.active ? 'success' : 'error'"
                          variant="flat"
                          size="large"
                          class="status-chip mt-3"
                        >
                          <v-icon left size="16">{{ user.active ? 'mdi-check' : 'mdi-close' }}</v-icon>
                          {{ getStatusAcc() }}
                        </v-chip>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card class="status-card">
                    <v-card-text>
                      <div class="status-card-content">
                        <div class="status-card-header">
                          <v-icon size="28" :color="user['2fa'] === 1 ? 'success' : 'grey'">
                            mdi-two-factor-authentication
                          </v-icon>
                          <span class="status-card-label">2FA Security</span>
                        </div>
                        <v-chip
                          :color="user['2fa'] === 1 ? 'success' : 'grey'"
                          variant="flat"
                          size="large"
                          class="status-chip mt-3"
                        >
                          <v-icon left size="16">{{ user['2fa'] === 1 ? 'mdi-lock' : 'mdi-lock-open' }}</v-icon>
                          {{ getStatus2FA() }}
                        </v-chip>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Disabled Account Warning -->
                <v-alert
                  v-if="!user.active"
                  type="error"
                  variant="outlined"
                  class="disabled-alert mt-4"
                >
                  <div class="alert-content">
                    <div class="alert-title">Account Disabled</div>
                    <div class="alert-text">
                      <p>Your account has been disabled since: <strong>{{ user.disabled_since }}</strong></p>
                      <p>You have 30 days to reactivate (until: <strong>{{ disabled_until }}</strong>)</p>
                      <p>After this date, we may permanently remove your account and all associated tokens will be lost.</p>
                    </div>
                  </div>
                </v-alert>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Account Actions Section -->
              <div class="actions-section">
                <h2 class="section-title">
                  <v-icon left>mdi-shield-edit</v-icon>
                  Account Actions
                </h2>

                <div class="actions-grid">
                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-lock-reset"
                    class="action-btn"
                    @click="emitForgot()"
                  >
                    Reset Password
                  </v-btn>

                  <v-btn
                    variant="outlined"
                    prepend-icon="mdi-email-edit"
                    class="action-btn"
                    @click="emitEmailChange()"
                  >
                    Change Email
                  </v-btn>

                  <v-btn
                    v-if="user['2fa'] === 0"
                    variant="outlined"
                    prepend-icon="mdi-shield-lock"
                    color="success"
                    class="action-btn"
                    @click="enable2FA()"
                  >
                    Enable 2FA
                  </v-btn>

                  <v-btn
                    v-if="user['2fa'] === 1"
                    variant="outlined"
                    prepend-icon="mdi-shield-off"
                    color="error"
                    class="action-btn"
                    @click="disable2FA()"
                  >
                    Disable 2FA
                  </v-btn>

                  <v-btn
                    v-if="user.active"
                    variant="outlined"
                    prepend-icon="mdi-account-off"
                    color="error"
                    class="action-btn"
                    @click="emitDisableAccount()"
                  >
                    Disable Account
                  </v-btn>

                  <v-btn
                    v-if="!user.active"
                    variant="outlined"
                    prepend-icon="mdi-account-check"
                    color="success"
                    class="action-btn"
                    @click="emitActivateAccount()"
                  >
                    Activate Account
                  </v-btn>
                </div>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- User Address Section -->
              <div class="address-section">
                <h2 class="section-title">
                  <v-icon left>mdi-home-account</v-icon>
                  User Address
                </h2>

                <div class="address-actions mb-4">
                  <v-btn
                    v-if="user.address === '' && !addaddress"
                    variant="outlined"
                    prepend-icon="mdi-plus"
                    class="action-btn"
                    @click="addAddress()"
                  >
                    Add Address
                  </v-btn>
                  <v-btn
                    v-if="user.address === '' && addaddress"
                    variant="outlined"
                    prepend-icon="mdi-close"
                    class="action-btn"
                    @click="addAddress()"
                  >
                    Cancel Adding
                  </v-btn>
                  <v-btn
                    v-if="user.address !== '' && !modifyaddress"
                    variant="outlined"
                    prepend-icon="mdi-pencil"
                    class="action-btn"
                    @click="modifyAddress()"
                  >
                    Modify Address
                  </v-btn>
                  <v-btn
                    v-if="user.address !== '' && modifyaddress"
                    variant="outlined"
                    prepend-icon="mdi-close"
                    class="action-btn"
                    @click="modifyAddress()"
                  >
                    Cancel Modify
                  </v-btn>
                </div>

                <!-- Display Address (Read-only) -->
                <div v-if="user.address !== '' && !modifyaddress" class="address-display">
                  <v-card class="info-card">
                    <v-card-text>
                      <div class="info-grid-two">
                        <div class="info-field-group">
                          <label class="field-label">Name</label>
                          <v-text-field
                            :model-value="user.name"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Given First Name"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">Surname</label>
                          <v-text-field
                            :model-value="user.surname"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Last Name"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Address</label>
                        <v-text-field
                          :model-value="user.address"
                          readonly
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          hint="Street and number"
                          persistent-hint
                          class="readonly-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Address Line 2</label>
                        <v-text-field
                          :model-value="user.address2"
                          readonly
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          hint="If address is too long, split it here"
                          persistent-hint
                          class="readonly-field"
                        ></v-text-field>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Postal Code</label>
                          <v-text-field
                            :model-value="user.postal"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Your location postal code"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">City</label>
                          <v-text-field
                            :model-value="user.city"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="City name"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Country</label>
                          <v-text-field
                            :model-value="user.country"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Your location country"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">Telephone</label>
                          <v-text-field
                            :model-value="user.tel"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Telephone number with + sign and country code"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Modify Address Form -->
                <div v-if="modifyaddress" class="address-form">
                  <v-card class="form-card">
                    <v-card-text>
                      <div class="info-grid-two">
                        <div class="info-field-group">
                          <label class="field-label">Name</label>
                          <v-text-field
                            v-model="modify_name"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Given First Name"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">Surname</label>
                          <v-text-field
                            v-model="modify_surname"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Last Name"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Address</label>
                        <v-text-field
                          v-model="modify_address"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Street and number"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Address Line 2</label>
                        <v-text-field
                          v-model="modify_address2"
                          variant="outlined"
                          density="comfortable"
                          hint="If address is too long, split it here"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Postal Code</label>
                          <v-text-field
                            v-model="modify_postal"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Your location postal code"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">City</label>
                          <v-text-field
                            v-model="modify_city"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="City name"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Country</label>
                          <v-select
                            v-model="modify_country"
                            :items="countries"
                            item-title="label"
                            item-value="label"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            class="editable-field"
                          ></v-select>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">Telephone</label>
                          <v-text-field
                            v-model="modify_tel"
                            variant="outlined"
                            density="comfortable"
                            hint="Telephone number with + sign and country code"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="form-actions mt-6">
                        <v-btn
                          variant="outlined"
                          color="success"
                          prepend-icon="mdi-content-save"
                          :disabled="!checkIfAddressChanged"
                          @click="saveAddress()"
                          class="action-btn"
                        >
                          Save Changes
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          color="error"
                          prepend-icon="mdi-delete"
                          @click="removeAddress()"
                          class="action-btn"
                        >
                          Remove Address
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Add Address Form -->
                <div v-if="addaddress" class="address-form">
                  <v-card class="form-card">
                    <v-card-text>
                      <!-- Similar structure to modify address form -->
                      <div class="info-grid-two">
                        <div class="info-field-group">
                          <label class="field-label">Name</label>
                          <v-text-field
                            v-model="add_name"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Given First Name"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">Surname</label>
                          <v-text-field
                            v-model="add_surname"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Last Name"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Address</label>
                        <v-text-field
                          v-model="add_address"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Street and number"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Address Line 2</label>
                        <v-text-field
                          v-model="add_address2"
                          variant="outlined"
                          density="comfortable"
                          hint="If address is too long, split it here"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Postal Code</label>
                          <v-text-field
                            v-model="add_postal"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Your location postal code"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">City</label>
                          <v-text-field
                            v-model="add_city"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="City name"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Country</label>
                          <v-select
                            v-model="add_country"
                            :items="countries"
                            item-title="label"
                            item-value="label"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            class="editable-field"
                          ></v-select>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">Telephone</label>
                          <v-text-field
                            v-model="add_tel"
                            variant="outlined"
                            density="comfortable"
                            hint="Telephone number with + sign and country code"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="form-actions mt-6">
                        <v-btn
                          variant="outlined"
                          color="success"
                          prepend-icon="mdi-plus"
                          :disabled="!checkIfAddressAdded"
                          @click="storeAddress()"
                          class="action-btn"
                        >
                          Add Address
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- Invoice Data Section -->
              <div class="invoice-section">
                <h2 class="section-title">
                  <v-icon left>mdi-file-document-outline</v-icon>
                  Invoice Data
                </h2>

                <div class="address-actions mb-4">
                  <v-btn
                    v-if="user.company === '' && !addcompany"
                    variant="outlined"
                    prepend-icon="mdi-plus"
                    class="action-btn"
                    @click="addCompany()"
                  >
                    Add Invoice Data
                  </v-btn>
                  <v-btn
                    v-if="user.company === '' && addcompany"
                    variant="outlined"
                    prepend-icon="mdi-close"
                    class="action-btn"
                    @click="addCompany()"
                  >
                    Cancel Adding
                  </v-btn>
                  <v-btn
                    v-if="user.company !== '' && !modifycompany"
                    variant="outlined"
                    prepend-icon="mdi-pencil"
                    class="action-btn"
                    @click="modifyCompany()"
                  >
                    Modify Invoice Data
                  </v-btn>
                  <v-btn
                    v-if="user.company !== '' && modifycompany"
                    variant="outlined"
                    prepend-icon="mdi-close"
                    class="action-btn"
                    @click="modifyCompany()"
                  >
                    Cancel Modify
                  </v-btn>
                </div>

                <!-- Display Invoice Data (Read-only) -->
                <div v-if="user.company !== '' && !modifycompany" class="address-display">
                  <v-card class="info-card">
                    <v-card-text>
                      <div class="info-field-group">
                        <label class="field-label">Company Name</label>
                        <v-text-field
                          :model-value="user.company"
                          readonly
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          hint="Legal company name"
                          persistent-hint
                          class="readonly-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">VAT Number</label>
                        <v-text-field
                          :model-value="user.companyvat"
                          readonly
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          hint="Company VAT identification number"
                          persistent-hint
                          class="readonly-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Company Address</label>
                        <v-text-field
                          :model-value="user.company_address"
                          readonly
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          hint="Company registered address"
                          persistent-hint
                          class="readonly-field"
                        ></v-text-field>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Postal Code</label>
                          <v-text-field
                            :model-value="user.company_postal"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Company postal code"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">City</label>
                          <v-text-field
                            :model-value="user.company_city"
                            readonly
                            variant="outlined"
                            density="comfortable"
                            hide-details="auto"
                            hint="Company city"
                            persistent-hint
                            class="readonly-field"
                          ></v-text-field>
                        </div>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Country</label>
                        <v-text-field
                          :model-value="user.company_country"
                          readonly
                          variant="outlined"
                          density="comfortable"
                          hide-details="auto"
                          hint="Company country"
                          persistent-hint
                          class="readonly-field"
                        ></v-text-field>
                      </div>

                    </v-card-text>
                  </v-card>
                </div>

                <!-- Modify Invoice Data Form -->
                <div v-if="modifycompany" class="address-form">
                  <v-card class="form-card">
                    <v-card-text>
                      <div class="info-field-group">
                        <label class="field-label">Company Name</label>
                        <v-text-field
                          v-model="modify_company"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Legal company name"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">VAT Number</label>
                        <v-text-field
                          v-model="modify_companyvat"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Company VAT identification number"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Company Address</label>
                        <v-text-field
                          v-model="modify_company_address"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Company registered address"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Postal Code</label>
                          <v-text-field
                            v-model="modify_company_postal"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Company postal code"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">City</label>
                          <v-text-field
                            v-model="modify_company_city"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Company city"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="info-field-group">
                          <label class="field-label">Country</label>
                          <v-select
                            v-model="modify_company_country"
                            :items="countries"
                            item-title="label"
                            item-value="label"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            class="editable-field"
                          ></v-select>
                      </div>

                      <div class="form-actions mt-6">
                        <v-btn
                          variant="outlined"
                          color="success"
                          prepend-icon="mdi-content-save"
                          :disabled="!checkIfCompanyChanged"
                          @click="saveCompany()"
                          class="action-btn"
                        >
                          Save Changes
                        </v-btn>
                        <v-btn
                          variant="outlined"
                          color="error"
                          prepend-icon="mdi-delete"
                          @click="removeCompany()"
                          class="action-btn"
                        >
                          Remove Invoice Data
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>

                <!-- Add Invoice Data Form -->
                <div v-if="addcompany" class="address-form">
                  <v-card class="form-card">
                    <v-card-text>
                      <div class="info-field-group">
                        <label class="field-label">Company Name</label>
                        <v-text-field
                          v-model="add_company"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Legal company name"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">VAT Number</label>
                        <v-text-field
                          v-model="add_companyvat"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Company VAT identification number"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-field-group mt-4">
                        <label class="field-label">Company Address</label>
                        <v-text-field
                          v-model="add_company_address"
                          variant="outlined"
                          density="comfortable"
                          :rules="kitname"
                          hint="Company registered address"
                          persistent-hint
                          class="editable-field"
                        ></v-text-field>
                      </div>

                      <div class="info-grid-two mt-4">
                        <div class="info-field-group">
                          <label class="field-label">Postal Code</label>
                          <v-text-field
                            v-model="add_company_postal"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Company postal code"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                        <div class="info-field-group">
                          <label class="field-label">City</label>
                          <v-text-field
                            v-model="add_company_city"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            hint="Company city"
                            persistent-hint
                            class="editable-field"
                          ></v-text-field>
                        </div>
                      </div>
                      <div class="info-field-group">
                          <label class="field-label">Country</label>
                          <v-select
                            v-model="add_company_country"
                            :items="countries"
                            item-title="label"
                            item-value="label"
                            variant="outlined"
                            density="comfortable"
                            :rules="kitname"
                            class="editable-field"
                          ></v-select>
                      </div>

                      <div class="form-actions mt-6">
                        <v-btn
                          variant="outlined"
                          color="success"
                          prepend-icon="mdi-plus"
                          :disabled="!checkIfCompanyAdded"
                          @click="storeCompany()"
                          class="action-btn"
                        >
                          Add Invoice Data
                        </v-btn>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>

              <v-divider class="my-6" style="opacity:0.3;"></v-divider>

              <!-- KYC Section -->
              <div class="kyc-section">
                <h2 class="section-title">
                  <v-icon left>mdi-card-account-details</v-icon>
                  Know Your Customer
                </h2>

                <div class="kyc-grid">
                  <!-- User ID Front -->
                  <v-card class="kyc-upload-card">
                    <v-card-text>
                      <div class="kyc-upload-content">
                        <div class="kyc-upload-header">
                          <v-icon size="32" color="white">mdi-card-account-details-outline</v-icon>
                          <h3 class="kyc-upload-title">User ID Front</h3>
                        </div>
                        <div class="kyc-status-wrapper">
                          <div :class="getKYCStatusClass(user.kyc_awers_verified, user.kyc_awers)" class="kyc-status">
                            <v-icon left size="20">{{ getKYCStatusIcon(user.kyc_awers_verified, user.kyc_awers) }}</v-icon>
                            <span>{{ GetKYCInfo(user.kyc_awers_verified, user.kyc_awers) }}</span>
                          </div>
                        </div>
                        <v-btn
                          :loading="isSelectingFront"
                          :disabled="user.kyc_awers_verified ? true : false"
                          variant="outlined"
                          prepend-icon="mdi-upload"
                          class="upload-btn mt-4"
                          @click="triggerUploadFront()"
                          block
                        >
                          Upload Front ID
                        </v-btn>
                        <v-progress-linear
                          v-if="isUploadingFront"
                          :model-value="progressUpF"
                          color="white"
                          height="4"
                          class="mt-4"
                        ></v-progress-linear>
                        <div v-if="isUploadingFront" class="upload-progress-text">
                          Uploading... {{ progressUpF }}%
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <!-- User ID Back -->
                  <v-card class="kyc-upload-card">
                    <v-card-text>
                      <div class="kyc-upload-content">
                        <div class="kyc-upload-header">
                          <v-icon size="32" color="white">mdi-card-account-details</v-icon>
                          <h3 class="kyc-upload-title">User ID Back</h3>
                        </div>
                        <div class="kyc-status-wrapper">
                          <div :class="getKYCStatusClass(user.kyc_rewers_verified, user.kyc_rewers)" class="kyc-status">
                            <v-icon left size="20">{{ getKYCStatusIcon(user.kyc_rewers_verified, user.kyc_rewers) }}</v-icon>
                            <span>{{ GetKYCInfo(user.kyc_rewers_verified, user.kyc_rewers) }}</span>
                          </div>
                        </div>
                        <v-btn
                          :loading="isSelectingBack"
                          :disabled="user.kyc_rewers_verified ? true : false"
                          variant="outlined"
                          prepend-icon="mdi-upload"
                          class="upload-btn mt-4"
                          @click="triggerUploadBack()"
                          block
                        >
                          Upload Back ID
                        </v-btn>
                        <v-progress-linear
                          v-if="isUploadingBack"
                          :model-value="progressUpB"
                          color="white"
                          height="4"
                          class="mt-4"
                        ></v-progress-linear>
                        <div v-if="isUploadingBack" class="upload-progress-text">
                          Uploading... {{ progressUpB }}%
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <!-- User Address -->
                  <v-card class="kyc-upload-card">
                    <v-card-text>
                      <div class="kyc-upload-content">
                        <div class="kyc-upload-header">
                          <v-icon size="32" color="white">mdi-home-city-outline</v-icon>
                          <h3 class="kyc-upload-title">User Address</h3>
                        </div>
                        <div class="kyc-status-wrapper">
                          <div :class="getKYCStatusClass(user.kyc_address_verified, user.kyc_address)" class="kyc-status">
                            <v-icon left size="20">{{ getKYCStatusIcon(user.kyc_address_verified, user.kyc_address) }}</v-icon>
                            <span>{{ GetKYCInfo(user.kyc_address_verified, user.kyc_address) }}</span>
                          </div>
                        </div>
                        <v-btn
                          :loading="isSelectingAddress"
                          :disabled="user.kyc_address_verified ? true : false"
                          variant="outlined"
                          prepend-icon="mdi-upload"
                          class="upload-btn mt-4"
                          @click="triggerUploadAddress()"
                          block
                        >
                          Upload Address Proof
                        </v-btn>
                        <v-progress-linear
                          v-if="isUploadingAddress"
                          :model-value="progressUpA"
                          color="white"
                          height="4"
                          class="mt-4"
                        ></v-progress-linear>
                        <div v-if="isUploadingAddress" class="upload-progress-text">
                          Uploading... {{ progressUpA }}%
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>

                  <!-- Company Registration -->
                  <v-card class="kyc-upload-card">
                    <v-card-text>
                      <div class="kyc-upload-content">
                        <div class="kyc-upload-header">
                          <v-icon size="32" color="white">mdi-file-sign</v-icon>
                          <h3 class="kyc-upload-title">Company Registration</h3>
                        </div>
                        <div class="kyc-status-wrapper">
                          <div :class="getKYCStatusClass(user.kyc_company_verified, user.kyc_company)" class="kyc-status">
                            <v-icon left size="20">{{ getKYCStatusIcon(user.kyc_company_verified, user.kyc_company) }}</v-icon>
                            <span>{{ GetKYCInfo(user.kyc_company_verified, user.kyc_company) }}</span>
                          </div>
                        </div>
                        <v-btn
                          :loading="isSelectingCompany"
                          :disabled="user.kyc_company_verified ? true : false"
                          variant="outlined"
                          prepend-icon="mdi-upload"
                          class="upload-btn mt-4"
                          @click="triggerUploadCompany()"
                          block
                        >
                          Upload Company Document
                        </v-btn>
                        <v-progress-linear
                          v-if="isUploadingCompany"
                          :model-value="progressUpC"
                          color="white"
                          height="4"
                          class="mt-4"
                        ></v-progress-linear>
                        <div v-if="isUploadingCompany" class="upload-progress-text">
                          Uploading... {{ progressUpC }}%
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>

            </div>
          </div>
        </div>
        <v-row :style="(isMobileXs || isMobilePlayer3) ? 'padding-top:170px!important':'padding-top:123px!important'"></v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { fa } from 'vuetify/locale';
import { useMobile } from '../composables/useMobile.js'
import { useMobilePlayer3 } from '../composables/useMobilePlayer3.js'
import { useMobileXs } from '../composables/useMobileXs.js'
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";
const countries = require('i18n-iso-countries')
countries.registerLocale(require('i18n-iso-countries/langs/en.json'))
import LogoWhite from '../components/logo_white.vue';

export default {
  setup() {
    const isMobile = useMobile()
    const isMobileXs = useMobileXs()
    const isMobilePlayer3 = useMobilePlayer3();

    const notify = (message) => {
      toast(message, {
        theme: "dark",
        type: "success",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 1500,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    const notifyError = (message) => {
      toast(message, {
        theme: "dark",
        type: "error",
        position: "bottom-center",
        closeOnClick: false,
        pauseOnHover: false,
        autoClose: 3000,
        transition: "flip",
        dangerouslyHTMLString: true,
      });
    };

    return { isMobile, isMobileXs, notify, notifyError, isMobilePlayer3 }
  },
  name: 'Settings',

  components: {
    LogoWhite
  },
  data: () => ({
    navbar: false,
    user: null,

    disabled_until: new Date(),
    disableAccBox: false,
    activateAccBox: false,
    changeEmailBox: false,
    deactivateAccOK: false,
    activateAccOK: false,
    changeEmailOK: false,
    disableAcc: false,
    enableAcc: false,
    changeEmail: false,

      passDisableAcc: '',
      passChangeEmail: '',
      emailNew: '',
      valueEmail: true,
      value: true,

      emailValidationErrors: [],

      // address
      addaddress: false,
      modifyaddress: false,
      addcompany: false,
      modifycompany: false,

      modify_name: '',
      modify_surname: '',
      modify_address: '',
      modify_address2: '',
      modify_postal: '',
      modify_city: '',
      modify_country: '',
      modify_tel: '',
      modify_company: '',
      modify_companyvat: '',
      modify_company_address: '',
      modify_company_postal: '',
      modify_company_city: '',
      modify_company_country: '',

      add_name: '',
      add_surname: '',
      add_address: '',
      add_address2: '',
      add_postal: '',
      add_city: '',
      add_country: '',
      add_tel: '',
      add_company: '',
      add_companyvat: '',
      add_company_address: '',
      add_company_postal: '',
      add_company_city: '',
      add_company_country: '',

      // UPLOAD
      isSelectingFront: false,
      isSelectingBack: false,
      isSelectingAddress: false,
      isSelectingCompany: false,

      selectedFileF: null,
      selectedFileB: null,
      selectedFileA: null,
      selectedFileC: null,

      isUploadingFront: false,
      isUploadingBack: false,
      isUploadingAddress: false,
      isUploadingCompany: false,

      progressUpF: 0,
      progressUpB: 0,
      progressUpA: 0,
      progressUpC: 0,

  }),
  mounted() {   
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {

  },
  destroyed() {
  },
  watch: {
    '$store.state.user': function() {
          this.user = this.$store.getters.getUserData;
      },    
      async emailNew(val) {
          this.emailValidationErrors = ['Checking..'];
          let resultcheck = /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(val)
          if (resultcheck){
            try {
              const res = await this.$store.dispatch('checkEmail', {email: val}); // If value has been changed since start of function quit because result of last launched win 
              if (val !== this.emailNew) return 
              
              if (res.data === 0) { 
                this.emailValidationErrors = ['E-mail already in use']; 
                return false;
              } else { 
                this.emailValidationErrors = []; 
                return true;
              } 
            } catch(error) {
              if (!error.response){
                this.emailValidationErrors = ['Service is down.. Try again later!'];
              } else if (error.response.status === 500) {
                this.emailValidationErrors = ['Service is down.. Try again later!'];
              } else {
                this.emailValidationErrors = ['E-mail already in use'];
              }
              return false;
            }
          } else {
            this.emailValidationErrors = ['E-mail must be valid'];
            return false;
          }
      },
      disableAccBox() {
          if(this.$refs.disableAccRef){
            this.$refs.disableAccRef.resetValidation();
          }
          this.disableAcc = false;
          this.passDisableAcc = '';
      },
      activateAccBox() {
          this.enableAcc = false;
      },
      changeEmailBox() {
          if (this.$refs.changeEmailRef) {
            this.$refs.changeEmailRef.resetValidation();
          }
          this.changeEmail = false;
          this.passChangeEmail = '';
          this.emailNew = '';
      },
  },
  computed: {
    isfullScreen(){
      if(this.isMobile && this.isMobileXs){
        return false;
      } else {
        return true;
      }
    },
    isLogged() {
          return this.$store.getters.getUserData != null
      },
    isDesktop() {
        if (!this.navbar){
          return true;
        } else {
          return false;
        }
      },
    getGextPanel() {
      if(this.navbar){
        if (this.isMobileXs) {
          return 'textPanelMobileXs'
        } else {
          return 'textPanelMobile';
        }
      } else return 'textPanel';
    },
    countries () {
      const list = countries.getNames('en', { select: 'official' })
      return Object.keys(list).map((key) => ({ value: key, label: list[key] }))
    },
    checkIfAddressAdded(){
      if (this.user){
          if (this.add_name === '' || this.add_surname === '' || this.add_address === '' || this.add_postal === '' || this.add_city === '' || this.add_country === ''){
            return false;
          } else {
            return true;
          }
      } else {
        return false;
      }
    },
    checkIfCompanyAdded(){
      if (this.user){
          if (this.add_company === '' || this.add_companyvat === '' || this.add_company_address === '' || this.add_company_postal === '' || this.add_company_city === '' || this.add_company_country === ''){
            return false;
          } else {
            return true;
          }
      } else {
        return false;
      }
    },
    checkIfAddressChanged(){
      if (this.user){
        if (this.modify_name !== this.user.name || 
            this.modify_surname !== this.user.surname ||
            this.modify_address !== this.user.address ||
            this.modify_address2 !== this.user.address2 ||
            this.modify_postal !== this.user.postal ||
            this.modify_city !== this.user.city ||
            this.modify_country !== this.user.country ||
            this.modify_tel !== this.user.tel
        ){
          if (this.modify_name === '' || this.modify_surname === '' || this.modify_address === '' || this.modify_postal === '' || this.modify_city === '' || this.modify_country === ''){
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    checkIfCompanyChanged(){
      if (this.user){
        if (this.modify_company !== this.user.company || 
            this.modify_companyvat !== this.user.companyvat ||
            this.modify_company_address !== this.user.company_address ||
            this.modify_company_postal !== this.user.company_postal ||
            this.modify_company_city !== this.user.company_city ||
            this.modify_company_country !== this.user.company_country
        ){
          if (this.modify_company === '' || this.modify_companyvat === '' || this.modify_company_address === '' || this.modify_company_postal === '' || this.modify_company_city === '' || this.modify_company_country === ''){
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    passwordRulesLogin() { return [
            v => { 
                    var vv = !!v 
                    if (vv) return true;
                    else {                     
                        return 'Password is required';                       
                    } 
                  }, 
            ]
      },
    emailRules() { return [
            v => {
                  var val= !!v
                  if(val){
                    return true
                  } else {
                    this.emailValidationErrors=[];
                    return 'E-mail is required'
                  }},
                v => {
                if (/.+@.+/.test(v)) {
                  return true;
                }
                  this.emailValidationErrors = [];
                  return 'E-mail must be valid';
                },
                v => {
                if (/(^.+@(\[?)[a-zA-Z0-9-.]+.([a-zA-Z]{2,3}|[0-9]{1,3})(]?)$)/.test(v)) {
                  return true;
                } else {
                  this.emailValidationErrors = [];
                  return 'E-mail must be valid';
                }
                },
                v => {
                const isValid = /^[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!'#$%&*+\\/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(v);
                if (isValid) {
                  return true;
                } else {
                  this.emailValidationErrors = [];
                  return 'E-mail must be valid';
                }
                }
              ]
      },
    kitname() {
        return [
              v => {
                    var val= !!v
                    if(val){
                      return true
                    } else {
                      return 'Mandatory field'
                  }},
              ]
      },
  },  
  created() {
    if (this.$store.getters.getUserData != null) {
      this.user = this.$store.getters.getUserData;
      

      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }

      if (!this.user.active){
      var new_date = new Date(this.user.disabled_since);
      this.disabled_until.setDate(new_date.getDate() + 30);
      }

      this.modify_name = this.user.name;
      this.modify_surname = this.user.surname;
      this.modify_address = this.user.address;
      this.modify_address2 = this.user.address2;
      this.modify_postal = this.user.postal;
      this.modify_city = this.user.city;
      this.modify_country = this.user.country;
      this.modify_tel = this.user.tel;
      this.modify_company = this.user.company;
      this.modify_companyvat = this.user.companyvat;
      this.modify_company_address = this.user.company_address;
      this.modify_company_postal = this.user.company_postal;
      this.modify_company_city = this.user.company_city;
      this.modify_company_country = this.user.company_country;

      this.emitter.on('disableAccount', () => {
            this.disableAccBox = true;
      })

      this.emitter.on('activateAccount', () => {
            this.activateAccBox = true;
      })

      this.emitter.on('changeEmail', () => {
            this.changeEmailBox = true;
            this.emailValidationErrors = [];
      })

      this.emitter.on('progressUploadF', (progress) => {
          this.progressUpF = progress;
      })
      this.emitter.on('progressUploadB', (progress) => {
          this.progressUpB = progress;
      })
      this.emitter.on('progressUploadA', (progress) => {
          this.progressUpA = progress;
      })
      this.emitter.on('progressUploadC', (progress) => {
          this.progressUpC = progress;
      })

    }
  }, 
  methods: {
    triggerUploadFront() {
        this.isSelectingFront = true;
        // After obtaining the focus when closing the FilePicker, return the button state to normal
        window.addEventListener('focus', () => {
               this.isSelectingFront = false
        }, { once: true });
                
        // Trigger click on the FileInput
        this.$refs.uploader2.click();
    },
    triggerUploadBack() {
        this.isSelectingBack = true;
        // After obtaining the focus when closing the FilePicker, return the button state to normal
        window.addEventListener('focus', () => {
               this.isSelectingBack = false
        }, { once: true });
                
        // Trigger click on the FileInput
        this.$refs.uploader3.click();
    },
    triggerUploadAddress() {
        this.isSelectingAddress = true;
        // After obtaining the focus when closing the FilePicker, return the button state to normal
        window.addEventListener('focus', () => {
               this.isSelectingAddress = false
        }, { once: true });
                
        // Trigger click on the FileInput
        this.$refs.uploader4.click();
    },
    triggerUploadCompany() {
        this.isSelectingCompany = true;
        // After obtaining the focus when closing the FilePicker, return the button state to normal
        window.addEventListener('focus', () => {
               this.isSelectingCompany = false
        }, { once: true });
                
        // Trigger click on the FileInput
        this.$refs.uploader5.click();
    },

    handleFileUploadFront(e){
      this.selectedFileF = e.target.files[0];

      if (this.selectedFileF){
        this.isSelectingFront = true;
        let formData = new FormData();
        formData.append('file', this.selectedFileF);
        formData.append('uid', this.user.uid);
        formData.append('size', parseFloat( ((this.selectedFileF.size / 1024) / 1024).toFixed(2) ));
        
        this.isUploadingFront = true;
        this.progressUpF = 0;

        this.$store.dispatch('upload2faFile', { 
          formData: formData,
          token: this.user.token
        }).then( response => {
          this.isSelectingFront = false; 
          this.selectedFileF = null;   
          this.isUploadingFront = false;   
          this.user = this.$store.getters.getUserData;
        }).catch( error => {
          this.isSelectingFront = false;
          this.selectedFileF = null;
          this.isUploadingFront = false;
          this.notifyError("Error occured.. Please try again later.");
        })
      }
    },


    handleFileUploadBack(e){
      this.selectedFileB = e.target.files[0];

      if (this.selectedFileB){
        this.isSelectingBack = true;
        let formData = new FormData();
        formData.append('file', this.selectedFileB);
        formData.append('uid', this.user.uid);
        formData.append('size', parseFloat( ((this.selectedFileB.size / 1024) / 1024).toFixed(2) ));
        
        this.isUploadingBack = true;
        this.progressUpB = 0;
        // Upload and run computations according to user level (backend check)
        // If level 3, store it also replacing old file
        this.$store.dispatch('upload2faFileRev', { 
          formData: formData,
          token: this.user.token
        } ).then( response => {
          this.isSelectingBack = false; 
          this.selectedFileB = null;   
          this.isUploadingBack = false;   
          this.user = this.$store.getters.getUserData;
        }).catch( error => {
          this.isSelectingBack = false;
          this.selectedFileB = null;
          this.isUploadingBack = false;
          this.notifyError("Error occured.. Please try again later.");
        })
      }
    },

    handleFileUploadAddress(e){
      this.selectedFileA = e.target.files[0];

      if (this.selectedFileA){
        this.isSelectingAddress = true;
        let formData = new FormData();
        formData.append('file', this.selectedFileA);
        formData.append('uid', this.user.uid);
        formData.append('size', parseFloat( ((this.selectedFileA.size / 1024) / 1024).toFixed(2) ));
        
        this.isUploadingAddress = true;
        this.progressUpA = 0;
        // Upload and run computations according to user level (backend check)
        // If level 3, store it also replacing old file
        this.$store.dispatch('upload2faFileAddress', { 
          formData: formData,
          token: this.user.token
        } ).then( response => {
          this.isSelectingAddress = false; 
          this.selectedFileA = null;   
          this.isUploadingAddress = false;   
          this.user = this.$store.getters.getUserData;
        }).catch( error => {
          this.isSelectingAddress = false;
          this.selectedFileA = null;
          this.isUploadingAddress = false;
          this.notifyError("Error occured.. Please try again later.");
        })
      }
    },

    handleFileUploadCompany(e){
      this.selectedFileC = e.target.files[0];

      if (this.selectedFileC){
        this.isSelectingCompany = true;
        let formData = new FormData();
        formData.append('file', this.selectedFileC);
        formData.append('uid', this.user.uid);
        formData.append('size', parseFloat( ((this.selectedFileC.size / 1024) / 1024).toFixed(2) ));
        
        this.isUploadingCompany = true;
        this.progressUpC = 0;
        // Upload and run computations according to user level (backend check)
        // If level 3, store it also replacing old file
        this.$store.dispatch('upload2faFileCompany', { 
          formData: formData,
          token: this.user.token
        } ).then( response => {
          this.isSelectingCompany = false; 
          this.selectedFileC = null;   
          this.isUploadingCompany = false;   
          this.user = this.$store.getters.getUserData;
        }).catch( error => {
          this.isSelectingCompany = false;
          this.selectedFileC = null;
          this.isUploadingCompany = false;
          this.notifyError("Error occured.. Please try again later.");
        })
      }
    },

    enable2FA(){
      this.$router.push({ name: 'enable2fa' });
    },
    disable2FA(){
      this.$router.push({ name: 'disable2fa' });
    },
    addAddress(){
      this.addaddress = !this.addaddress;
    },
    modifyAddress(){
      this.modifyaddress = !this.modifyaddress;
    },
    saveAddress(){
      this.$store.dispatch('storeAddress',{   token: this.user.token, 
                                              name: this.modify_name, 
                                              surname: this.modify_surname,
                                              address: this.modify_address,
                                              address2: this.modify_address2,
                                              postal: this.modify_postal,
                                              city: this.modify_city,
                                              country: this.modify_country,
                                              tel: this.modify_tel
                                            }).then( response => {        
      this.user = this.$store.getters.getUserData;

        this.modify_name = this.user.name;
        this.modify_surname = this.user.surname;
        this.modify_address = this.user.address;
        this.modify_address2 = this.user.address2;
        this.modify_postal = this.user.postal;
        this.modify_city = this.user.city;
        this.modify_country = this.user.country;
        this.modify_tel = this.user.tel;
        this.modify_company = this.user.company;
        this.modify_companyvat = this.user.companyvat;
        this.modify_company_address = this.user.company_address;
        this.modify_company_postal = this.user.company_postal;
        this.modify_company_city = this.user.company_city;
        this.modify_company_country = this.user.company_country;
                                              

        this.modifyaddress = false;

      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error storing address. Please try again later.");
        }
      })
    },
    storeAddress(){
      this.$store.dispatch('storeAddress',{   token: this.user.token, 
                                              name: this.add_name, 
                                              surname: this.add_surname,
                                              address: this.add_address,
                                              address2: this.add_address2,
                                              postal: this.add_postal,
                                              city: this.add_city,
                                              country: this.add_country,
                                              tel: this.add_tel
                                            }).then( response => {        
      this.user = this.$store.getters.getUserData;

        this.modify_name = this.user.name;
        this.modify_surname = this.user.surname;
        this.modify_address = this.user.address;
        this.modify_address2 = this.user.address2;
        this.modify_postal = this.user.postal;
        this.modify_city = this.user.city;
        this.modify_country = this.user.country;
        this.modify_tel = this.user.tel;
        this.modify_company = this.user.company;
        this.modify_companyvat = this.user.companyvat;
        this.modify_company_address = this.user.company_address;
        this.modify_company_postal = this.user.company_postal;
        this.modify_company_city = this.user.company_city;
        this.modify_company_country = this.user.company_country;

        this.addaddress = false;

      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error storing address. Please try again later.");
        }
      })
    },
    removeAddress(){
      this.$store.dispatch('removeAddress',{ token: this.user.token
                                            }).then( response => {        
      this.user = this.$store.getters.getUserData;

        this.modify_name = this.user.name;
        this.modify_surname = this.user.surname;
        this.modify_address = this.user.address;
        this.modify_address2 = this.user.address2;
        this.modify_postal = this.user.postal;
        this.modify_city = this.user.city;
        this.modify_country = this.user.country;
        this.modify_tel = this.user.tel;
        this.modify_company = this.user.company;
        this.modify_companyvat = this.user.companyvat;
        this.modify_company_address = this.user.company_address;
        this.modify_company_postal = this.user.company_postal;
        this.modify_company_city = this.user.company_city;
        this.modify_company_country = this.user.company_country;

        this.modifyaddress = false;

      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error removing address. Please try again later.");
        }
      })
    },
    addCompany(){
      this.addcompany = !this.addcompany;
    },
    modifyCompany(){
      this.modifycompany = !this.modifycompany;
    },
    saveCompany(){
      this.$store.dispatch('storeCompany',{   token: this.user.token, 
                                              company: this.modify_company, 
                                              companyvat: this.modify_companyvat,
                                              company_address: this.modify_company_address,
                                              company_postal: this.modify_company_postal,
                                              company_city: this.modify_company_city,
                                              company_country: this.modify_company_country
                                            }).then( response => {        
      this.user = this.$store.getters.getUserData;

        this.modify_name = this.user.name;
        this.modify_surname = this.user.surname;
        this.modify_address = this.user.address;
        this.modify_address2 = this.user.address2;
        this.modify_postal = this.user.postal;
        this.modify_city = this.user.city;
        this.modify_country = this.user.country;
        this.modify_tel = this.user.tel;
        this.modify_company = this.user.company;
        this.modify_companyvat = this.user.companyvat;
        this.modify_company_address = this.user.company_address;
        this.modify_company_postal = this.user.company_postal;
        this.modify_company_city = this.user.company_city;
        this.modify_company_country = this.user.company_country;

        this.modifycompany = false;

      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error storing company. Please try again later.");
        }
      })
    },
    storeCompany(){
      this.$store.dispatch('storeCompany',{   token: this.user.token, 
                                              company: this.add_company, 
                                              companyvat: this.add_companyvat,
                                              company_address: this.add_company_address,
                                              company_postal: this.add_company_postal,
                                              company_city: this.add_company_city,
                                              company_country: this.add_company_country
                                            }).then( response => {        
      this.user = this.$store.getters.getUserData;

        this.modify_name = this.user.name;
        this.modify_surname = this.user.surname;
        this.modify_address = this.user.address;
        this.modify_address2 = this.user.address2;
        this.modify_postal = this.user.postal;
        this.modify_city = this.user.city;
        this.modify_country = this.user.country;
        this.modify_tel = this.user.tel;
        this.modify_company = this.user.company;
        this.modify_companyvat = this.user.companyvat;
        this.modify_company_address = this.user.company_address;
        this.modify_company_postal = this.user.company_postal;
        this.modify_company_city = this.user.company_city;
        this.modify_company_country = this.user.company_country;

        this.addcompany = false;

      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error storing company. Please try again later.");
        }
      })
    },
    removeCompany(){
      this.$store.dispatch('removeCompany',{ token: this.user.token
                                            }).then( response => {        
      this.user = this.$store.getters.getUserData;

        this.modify_name = this.user.name;
        this.modify_surname = this.user.surname;
        this.modify_address = this.user.address;
        this.modify_address2 = this.user.address2;
        this.modify_postal = this.user.postal;
        this.modify_city = this.user.city;
        this.modify_country = this.user.country;
        this.modify_tel = this.user.tel;
        this.modify_company = this.user.company;
        this.modify_companyvat = this.user.companyvat;
        this.modify_company_address = this.user.company_address;
        this.modify_company_postal = this.user.company_postal;
        this.modify_company_city = this.user.company_city;
        this.modify_company_country = this.user.company_country;

        this.modifycompany = false;

      }).catch( error => {
        if (!error.response) {
          this.notifyError("Error removing company. Please try again later.");
        }
      })
    },
    disableAccFun(e){
        this.disableAcc = false;
        this.passDisableAcc = this.passDisableAcc.trim();

        this.$store.dispatch('disableAccount', { token: this.user.token, pass: this.passDisableAcc }).then( response => {
            this.user = this.$store.getters.getUserData;
            this.deactivateAccOK = true;
            var new_date = new Date(this.user.disabled_since);
            this.disabled_until.setDate(new_date.getDate() + 30);

        }).catch( error => {
          this.notifyError("Error disabling account. Please try again later.");
        })
    },
    activateAccFun(e){
        this.enableAcc = false;
        this.$store.dispatch('enableAccount', { token: this.user.token }).then( response => {
            this.user = this.$store.getters.getUserData;
            this.activateAccOK = true;

        }).catch( error => {
          this.notifyError("Error activating account. Please try again later.");
        })
    },
    changeEmailFun(e){
        this.changeEmail = false;
        this.passChangeEmail = this.passChangeEmail.trim();
        this.emailNew = this.emailNew.trim();

        this.$store.dispatch('changeEmail', { pass: this.passChangeEmail, token: this.user.token, uid: this.user.uid, newemail: this.emailNew }).then( response => {
            this.user = this.$store.getters.getUserData;
            this.changeEmailOK = true;
        }).catch( error => {
          this.changeEmail = false;
          this.passChangeEmail = '';
          this.emailNew = '';
          this.notifyError("Error e-mail change. Please try again later.");         
        })
    },
    closeDialogDisableAcc() {
        this.disableAccBox = false;
    },
    emitForgot(){
      this.$store.dispatch('forgotpasstoken', { token: this.user.token }
      ).then(response => {
        var tokreset = response.data.token;
        this.$router.push({ name: 'resetinternal', params: { token: tokreset } });
      }).catch(error => {
        if (!error.response) {
          this.notifyError("Service is down.. Try again later!");
        } else {
          this.notifyError("Error occured.. Try again later!");
        }
      });
    },
    emitEmailChange(){
         this.emitter.emit('changeEmail');
    },
    closeDialogActivateAcc() {
        this.activateAccBox = false;      
    },
    closeDialogChangeEmail() {
        this.changeEmailBox = false;
    },
    emitDisableAccount(){
         this.emitter.emit('disableAccount');
    },
    emitActivateAccount(){
         this.emitter.emit('activateAccount');
    },
    checkErrors() {
      if(!(this.passDisableAcc === '')){
        this.disableAcc = true;
      }
    },
    checkErrorsRegister() {
        if (this.emailValidationErrors.length != 0
            && (this.emailValidationErrors[0] === 'Service is down.. Try again later!' ||
                 this.emailValidationErrors[0] === 'Sign Up failed..')){
            this.emailValidationErrors = [];
        }
    },
    getLevel(lvl) {
      if (lvl == 0){
        return 'No Subscription'
      } else if (lvl === 1) {
        return 'Standard Access'
      } else {
        return 'Premium Access'
      }
    },
    getStatusAcc() {
      if (this.user.active){
        return 'Active'
      } else {
        return 'Disabled'
      }
    },
    getStatus2FA() {
      if (this.user['2fa'] === 1){
        return 'Enabled'
      } else {
        return 'Disabled'
      }
    },
    GetKYCInfo(verified, value){
      if (verified === 1){
        return 'Verified';
      } else if (value === ''){
        return 'Not Verified';
      } else {
        return 'Verification in progress';
      }
    },
    getKYCStatusClass(verified, value) {
      if (verified === 1) {
        return 'kyc-status-verified';
      } else if (value === '') {
        return 'kyc-status-not-verified';
      } else {
        return 'kyc-status-pending';
      }
    },

    getKYCStatusIcon(verified, value) {
      if (verified === 1) {
        return 'mdi-check-circle';
      } else if (value === '') {
        return 'mdi-alert-circle';
      } else {
        return 'mdi-clock-outline';
      }
    },
    checkScreenSize() {
      if(window.innerWidth > 768){
        this.navbar = false;
      } else {
        this.navbar = true;
      }
    },
    handleClickMenu(link){
      if (link === 'TryMuzE'){
        window.location.href = 'https://muze.muzible.com/';
      } else if (link === 'TryVerse'){
        window.location.href = 'https://verse.muzible.com/';
      } else {
        if (this.$route.name !== link ) {
          this.$router.push({ name: link });
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@use './css/styles.scss';

/* Settings Header */
.settings-header {
  margin-bottom: 24px;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 12px;
}

.header-icon {
  font-size: 48px !important;
  color: white;
}

.header-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 42px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.header-subtitle {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0 0 20px 0;
  line-height: 1.5;
}

/* Section Title */
.section-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 28px;
  font-weight: 600;
  color: white;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Settings Section */
.settings-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

/* Status Cards */
.status-cards-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.status-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  padding: 8px;
}

.status-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.status-card-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.status-card-header {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-card-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: white;
}

.status-chip {
  font-family: "Darker Grotesque", sans-serif !important;
  font-weight: 600 !important;
  align-self: flex-start;
}

/* Disabled Alert */
.disabled-alert {
  background: rgba(226, 71, 75, 0.1) !important;
  border: 1px solid rgba(226, 71, 75, 0.4) !important;
  border-radius: 12px !important;

  :deep(.v-alert__content) {
    color: white !important;
  }
}

.alert-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.alert-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: white;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.alert-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;

  p {
    margin: 4px 0;
  }

  strong {
    color: #e2474b;
    font-weight: 600;
  }
}

/* Actions Section */
.actions-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.actions-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.action-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
  transition: all 0.2s;
}

.action-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-2px);
}

/* Address Section */
.address-section,
.invoice-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.address-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.info-card,
.form-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  padding: 8px;
}

.info-card:hover,
.form-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
}

.info-grid-two {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

@media (max-width: 600px) {
  .info-grid-two {
    grid-template-columns: 1fr;
  }
}

.info-field-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: white;
}

.readonly-field,
.editable-field {
  font-family: "Darker Grotesque", sans-serif !important;

  :deep(.v-field) {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
    transition: all 0.3s ease;
  }

  :deep(.v-field__input) {
    color: white !important;
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 15px !important;
    font-weight: 500;
  }

  :deep(.v-field--disabled) {
    opacity: 1;
  }

  :deep(.v-messages) {
    color: rgba(255, 255, 255, 0.6) !important;
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 13px !important;
  }
}

.editable-field {
  :deep(.v-field:hover:not(.v-field--disabled)) {
    border-color: rgba(255, 255, 255, 0.4) !important;
  }

  :deep(.v-field--focused) {
    border-color: rgba(255, 255, 255, 0.6) !important;
  }
}

.form-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

/* KYC Section */
.kyc-section {
  margin-bottom: 32px;
  animation: slideIn 0.4s ease forwards;
}

.kyc-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 20px;
}

.kyc-upload-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.5), rgba(18, 18, 18, 0.5));
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.3s ease;
  padding: 16px;
}

.kyc-upload-card:hover {
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-4px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}

.kyc-upload-content {
  display: flex;
  flex-direction: column;
}

.kyc-upload-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.kyc-upload-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: white;
  text-align: center;
}

.kyc-status-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.kyc-status {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 8px;
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  font-weight: 600;
}

.kyc-status-verified {
  background: rgba(76, 175, 80, 0.2);
  color: #4caf50;
  border: 1px solid #4caf50;
}

.kyc-status-not-verified {
  background: rgba(226, 71, 75, 0.2);
  color: #e2474b;
  border: 1px solid #e2474b;
}

.kyc-status-pending {
  background: rgba(255, 152, 0, 0.2);
  color: #ff9800;
  border: 1px solid #ff9800;
}

.upload-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.upload-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.upload-progress-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  text-align: center;
  margin-top: 8px;
}


/* Dialogs */
.settings-dialog-card {
  background: linear-gradient(145deg, rgba(26, 26, 26, 0.98), rgba(18, 18, 18, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
}

.dialog-field {
  font-family: "Darker Grotesque", sans-serif !important;

  :deep(.v-field) {
    background: rgba(255, 255, 255, 0.05) !important;
    border: 1px solid rgba(255, 255, 255, 0.2) !important;
    border-radius: 8px !important;
  }

  :deep(.v-field__input) {
    color: white !important;
    font-family: "Darker Grotesque", sans-serif !important;
    font-size: 15px !important;
  }

  :deep(.v-label) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-family: "Darker Grotesque", sans-serif !important;
  }
}

.dialog-btn {
  font-family: "Darker Grotesque", sans-serif !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  border-color: rgba(255, 255, 255, 0.3) !important;
}

.dialog-btn:hover {
  background: rgba(255, 255, 255, 0.1) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

.dialog-confirm-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 16px;
  color: white;
  line-height: 1.6;
}

.success-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.success-title {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: white;
  margin: 0;
}

.success-text {
  font-family: "Darker Grotesque", sans-serif;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  text-align: center;
  line-height: 1.6;
}

/* Animations */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .header-title {
    font-size: 32px;
  }

  .status-cards-grid,
  .actions-grid,
  .kyc-grid {
    grid-template-columns: 1fr;
  }

  .address-actions,
  .form-actions {
    flex-direction: column;

    .action-btn {
      width: 100%;
    }
  }
}

/* Override Vuetify */
:deep(.v-btn:hover) > .v-btn__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-list-item:hover) > .v-list-item__overlay {
  --v-hover-opacity: 0.1;
  opacity: 0.1;
}

:deep(.v-select__selection-text) {
  color: white !important;
}
</style>
